import firebase from 'firebase'

const firebaseConfig = {
  apiKey: 'AIzaSyBcnLvmdAtxDNtzB5vYUGDajTSkSelz68w',
  authDomain: 'ibbil-2f368.firebaseapp.com',
  projectId: 'ibbil-2f368',
  storageBucket: 'ibbil-2f368.firebasestorage.app',
  messagingSenderId: '63224202655',
  appId: '1:63224202655:web:e7e951c1f9e85e1502e9aa',
  measurementId: 'G-BBP854SG63'
}
firebase.initializeApp(firebaseConfig)
